import { Component,inject, effect } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../../common/services/auth.service';
import { MenubarModule } from 'primeng/menubar';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, MenubarModule, SharedModule, ButtonModule],
  templateUrl: './header.html',
  styleUrls: ['./header.css']
})
export class HeaderComponent {
  items: any[] = [];
  private authService = inject(AuthService);
  private router = inject(Router);
  
  // Use signal from AuthService
  isUserLoggedIn = this.authService.isUserLoggedIn;
  allowDebug = environment.allowDebug
  
  constructor() {
    // Reactively update items when login state changes
    effect(() => {
      if (this.isUserLoggedIn()) {
        this.items = [
          {
            label: 'Manage Tools',
            icon: 'pi pi-cog',
            command: () => this.router.navigate(['/view-tools'])
          },
          {
            label: 'Shell Courses',
            icon: 'pi pi-box',
            styleClass: 'menu-bold',
            command: () => this.router.navigate(['/view-shell-courses'])
          },
          {
            label: 'Lessons for Deeplinking',
            icon: 'pi pi-plus',
            styleClass: 'menu-bold',
            command: () => this.router.navigate(['/view-lessons'])
          },
          {
            label: 'Line Items',
            icon: 'pi pi-book',
            styleClass: 'menu-bold',
            command: () => this.router.navigate(['/view-line-items'])
          }
        ];
      } else {
        this.items = [];
      }
    });
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
  goToChangePassword(){
    this.router.navigate(['/change-password']);
  }
  goDebugPage(){
    this.router.navigate(['/debug']);
  }
}

